const translation = {
  // ===== FinancialModel 国际化 =====
  "FinancialModel.analysisSuffix": " - Finanzanalyse",
  "FinancialModel.efficiencyAnalysis.coreStaffAnnualSalary":
    "Jahresgehalt des Kernpersonals",
  "FinancialModel.efficiencyAnalysis.maAnnualSalary": "Jahresgehalt von Ma",
  "FinancialModel.efficiencyAnalysis.liaoAnnualSalary": "Jahresgehalt von Liao",
  "FinancialModel.efficiencyAnalysis.totalAnnualLaborCost":
    "Gesamte jährliche Arbeitskosten",
  "FinancialModel.costStructure.cost_cloud": "Cloud-Service-Software",
  "FinancialModel.costStructure.cost_labor": "Arbeitskosten",
  "FinancialModel.costStructure.cost_marketing": "Marketing und Vertrieb",
  "FinancialModel.costStructure.cost_misc": "Sonstige Rücklagen",
  "FinancialModel.costStructure.cost_material":
    "Forschung und Entwicklung Material und Ausrüstung",
  "FinancialModel.costStructure.cost_admin": "Verwaltung und Compliance",
  "FinancialModel.efficiencyAnalysis.totalProjects": "Gesamtzahl der Projekte",
  "FinancialModel.efficiencyAnalysis.activeProjects": "Laufende Projekte",
  "FinancialModel.efficiencyAnalysis.blockedProjects": "Blockierte Projekte",
  "FinancialModel.efficiencyAnalysis.completedProjects":
    "Abgeschlossene Projekte",
  "FinancialModel.efficiencyAnalysis.analysisDescriptionTitle":
    "Projektanalysebeschreibung",
  "FinancialModel.efficiencyAnalysis.analysisDescription":
    "{{totalProjects}} Projektaufgaben, Ma und Liao erhalten jeweils ein monatliches Grundgehalt von 10.000 Yuan. Die Projektanalyse berücksichtigt die Projektbeteiligung der Mitarbeiter, die Priorität der Aufgaben und den Projektabschlussstatus, um datenbasierte Unterstützung für das Projektmanagement zu bieten.",
  "FinancialModel.efficiencyAnalysis.corePersonnelSalaryTitle":
    "Jahresgehalt des Kernpersonals",
  "FinancialModel.efficiencyAnalysis.personMaSalary": "Jahresgehalt von Ma:",
  "FinancialModel.efficiencyAnalysis.personLiaoSalary":
    "Jahresgehalt von Liao:",
  "FinancialModel.efficiencyAnalysis.totalLaborCost":
    "Gesamte jährliche Arbeitskosten:",
  "FinancialModel.efficiencyAnalysis.projectParticipationAnalysis":
    "Projektbeteiligungsanalyse",
  "FinancialModel.efficiencyAnalysis.allTime": "Gesamtzeit",
  "FinancialModel.efficiencyAnalysis.taskStatus": "Aufgabenstatus",
  "FinancialModel.efficiencyAnalysis.participation": "Beteiligung",
  "FinancialModel.efficiencyAnalysis.completionRate": "Abschlussrate",
  "FinancialModel.monthlyAnalysis.monthlyExpenseTrend":
    "Monatlicher Ausgabentrend",
  "FinancialModel.monthlyAnalysis.expenseAnalysisMethodology":
    "Methodik der monatlichen Ausgabenanalyse",
  "FinancialModel.monthlyAnalysis.methodologyBaseCost":
    "• Basiskosten: Festgehälter (Ma, Liao jeweils 10.000 Yuan/Monat)",
  "FinancialModel.monthlyAnalysis.methodologyProjectExpense":
    "• Projektkosten: Basierend auf der Anzahl aktiver Projekte",
  "FinancialModel.monthlyAnalysis.methodologyExpenseCategory":
    "• Ausgabenkategorien: Personalkosten und Projektkosten",
  "FinancialModel.monthlyAnalysis.keyMetricsDescription":
    "Beschreibung der Schlüsselkennzahlen",
  "FinancialModel.monthlyAnalysis.metricTotalExpense":
    "• Monatliche Gesamtausgaben = Personalkosten + Projektkosten",
  "FinancialModel.monthlyAnalysis.metricLaborCost":
    "• Personalkosten: Festgehälter + Projektleistung (falls zutreffend)",
  "FinancialModel.monthlyAnalysis.metricProjectExpense":
    "• Projektkosten: Budget von 2000 Yuan pro aktivem Projekt",
  "FinancialModel.monthlyAnalysis.metricExpenseEfficiency":
    "• Ausgabeneffizienz = Abschlussrate / Gesamtausgaben",
  "FinancialModel.costStructure.pieTitle":
    "Analyse der Ausgabenstruktur (basierend auf tatsächlichen Erstattungsdaten)",
  "FinancialModel.costStructure.detailTitle":
    "Kostenaufstellung (basierend auf tatsächlichen Erstattungsdaten)",
  "FinancialModel.costStructure.total":
    "Gesamtkosten (kumulierte Erstattungen)",
  "FinancialModel.costStructure.recordTitle":
    "Detaillierte Erstattungsaufzeichnungen",
  "FinancialModel.costStructure.table.category": "Kategorie",
  "FinancialModel.costStructure.table.desc": "Beschreibung",
  "FinancialModel.costStructure.table.amount": "Betrag",
  "FinancialModel.costStructure.人力成本": "Arbeitskosten",
  "FinancialModel.costStructure.研发材料设备":
    "Forschung und Entwicklung Material und Ausrüstung",
  "FinancialModel.costStructure.云服务软件": "Cloud-Service-Software",
  "FinancialModel.costStructure.市场与销售": "Marketing und Vertrieb",
  "FinancialModel.costStructure.行政与合规": "Verwaltung und Compliance",
  "FinancialModel.costStructure.杂项预备金": "Sonstige Rücklagen",
  "FinancialModel.expenseForecast.section1Title":
    "1. Runway-Veränderungstrend (Monate)",
  "FinancialModel.expenseForecast.methodTitle": "Prognosemethode:",
  "FinancialModel.expenseForecast.methodFormula":
    "Runway = Aktueller Kassenbestand ÷ Monatliche Gesamtausgaben.",
  "FinancialModel.expenseForecast.baseCaseDesc":
    "Annahme: Ausgaben bleiben im aktuellen Trend konstant;",
  "FinancialModel.expenseForecast.bestCaseDesc":
    "Annahme: Ausgaben sinken vierteljährlich um 5%;",
  "FinancialModel.expenseForecast.worstCaseDesc":
    "Annahme: Ausgaben steigen vierteljährlich um 5%.",
  "FinancialModel.expenseForecast.section1Explain":
    "Runway (Cashflow-nachhaltige Monate) zeigt die Anzahl der Monate, die ein Unternehmen mit dem aktuellen Bargeldbestand und Ausgabentempo betrieben werden kann. Das Trenddiagramm zeigt die Runway-Veränderung im nächsten Jahr unter verschiedenen Szenarien (Basis, optimistisch, konservativ) und hilft dem Management, die finanzielle Sicherheit und den Entscheidungsspielraum zu bewerten.",
  "FinancialModel.expenseForecast.baseCase": "Basisfall",
  "FinancialModel.expenseForecast.baseCaseExplain":
    "Annahme, dass Einnahmen und Ausgaben dem aktuellen Trend folgen, die Runway verkürzt sich allmählich, Aufmerksamkeit auf die Liquiditätslage erforderlich.",
  "FinancialModel.expenseForecast.bestCase": "Best Case (Optimistisch)",
  "FinancialModel.expenseForecast.bestCaseExplain":
    "Einnahmensteigerung und Kostenoptimierung verlängern die Runway, erhöhen die Risikotragfähigkeit des Unternehmens.",
  "FinancialModel.expenseForecast.worstCase": "Worst Case (Konservativ)",
  "FinancialModel.expenseForecast.worstCaseExplain":
    "Einnahmen stagnieren oder Kosten steigen, Runway verkürzt sich stark, frühzeitige Warnung und Gegenmaßnahmen erforderlich.",
  "FinancialModel.expenseForecast.scenarioForecastTitle":
    "Szenarioprognose - Runway-Veränderungstrend (Monate)",
  "FinancialModel.expenseForecast.yAxisFormatter":
    "{{v}} Monate (nachhaltige Betriebsmonate)",
  "FinancialModel.expenseForecast.healthyLabel":
    "Gesund: Mittel reichen für mehr als 12 Monate",
  "FinancialModel.expenseForecast.alertLabel":
    "Warnung: Mittel reichen für weniger als 6 Monate",
  "FinancialModel.expenseForecast.noticeLabel":
    "Hinweis: Mittel reichen für 6-12 Monate",
  "FinancialModel.expenseForecast.section2Title": "2. Treiberprognose",
  "FinancialModel.expenseForecast.laborCost": "Arbeitskosten",
  "FinancialModel.expenseForecast.laborCostFormula":
    "Anzahl der Mitarbeiter × Durchschnittsgehalt",
  "FinancialModel.expenseForecast.laborCostCurrent":
    "Aktuell: 2 Personen × ¥10.000 = ¥20.000/Monat",
  "FinancialModel.expenseForecast.materialCost": "Forschungskosten",
  "FinancialModel.expenseForecast.materialCostFormula":
    "Anzahl der Forscher × Durchschnittliche Materialkosten",
  "FinancialModel.expenseForecast.materialCostCurrent":
    "Aktuell: 2 Personen × ¥3.000 = ¥6.000/Monat",
  "FinancialModel.expenseForecast.cloudCost": "Cloud-Service-Kosten",
  "FinancialModel.expenseForecast.cloudCostFormula":
    "Aktive Nutzer × Kosten pro Nutzer",
  "FinancialModel.expenseForecast.cloudCostCurrent":
    "Erwartet: 100 Nutzer × ¥30 = ¥3.000/Monat",
  "FinancialModel.expenseForecast.driverForecastTrend":
    "Treiberprognose - Kostentrend",
  "FinancialModel.expenseForecast.section3Title": "3. Szenarioprognose",
  "FinancialModel.expenseForecast.baseCaseSituation": "Basisfall",
  "FinancialModel.expenseForecast.baseCaseIncome":
    "• Einnahmensteigerung um 10%",
  "FinancialModel.expenseForecast.baseCaseMarket":
    "• Marktaufwand bleibt konstant",
  "FinancialModel.expenseForecast.baseCaseRunway": '{">"} Runway: 18 Monate',
  "FinancialModel.expenseForecast.bestCaseSituation": "Best Case",
  "FinancialModel.expenseForecast.bestCaseIncome":
    "• Einnahmensteigerung um 20%",
  "FinancialModel.expenseForecast.bestCaseHardware":
    "• Massenbeschaffung, Hardwarekosten -10%",
  "FinancialModel.expenseForecast.bestCaseRunway": '{">"} Runway: 24 Monate',
  "FinancialModel.expenseForecast.worstCaseSituation": "Worst Case",
  "FinancialModel.expenseForecast.worstCaseIncome": "• Einnahmen 0 Wachstum",
  "FinancialModel.expenseForecast.worstCaseChip": "• Chippreise +20%",
  "FinancialModel.expenseForecast.worstCaseRunway": '{">"} Runway: 12 Monate',
  "FinancialModel.expenseForecast.unitEconomicsTrend":
    "Trend der Einheitökonomie",
  "FinancialModel.expenseForecast.section4Title":
    "4. Analyse der Einheitökonomie",
  "FinancialModel.expenseForecast.cac": "Kundenakquisitionskosten (CAC)",
  "FinancialModel.expenseForecast.cacFormula":
    "Gesamtausgaben für Marketing ÷ Anzahl neuer Nutzer",
  "FinancialModel.expenseForecast.ltv": "Lebenszeitwert (LTV)",
  "FinancialModel.expenseForecast.ltvFormula":
    "Bruttogewinn pro Einheit × Lebensdauer (Monate)",
  "FinancialModel.expenseForecast.unitEconomicsRatio":
    "Verhältnis der Einheitökonomie",
  "FinancialModel.expenseForecast.unitEconomicsRatioExplain":
    'LTV/CAC {">"} 3 bedeutet gesundes Modell',
  "FinancialModel.expenseForecast.sensitivityAnalysisTitle":
    "Sensitivitätsanalyse - Auswirkungen von Kostenänderungen auf die Runway (Monate)",
  "FinancialModel.loading": "Lädt...",
  "FinancialModel.error": "Fehler",
  "FinancialModel.tab.monthlyAnalysis": "Monatliche Analyse",
  "FinancialModel.tab.expenseForecast": "Ausgabenprognose",
  "FinancialModel.tab.costStructure": "Kostenstruktur",
  "FinancialModel.tab.efficiencyAnalysis": "Effizienzanalyse",
  "FinancialModel.pageTitle": "LUKKEY Projektanalyse",
  "FinancialModel.fundStatusAnalysis": "Analyse des Finanzstatus",
  "FinancialModel.status.warning": "Achtung erforderlich",
  "FinancialModel.status.healthy": "Gesundheitsstatus",
  "FinancialModel.status.notice": "Hinweis",
  "FinancialModel.status.alert": "Warnung",
  "FinancialModel.fundSupportDuration": "Finanzierungsdauer",
  "FinancialModel.month": "Monate",
  "FinancialModel.warningLine": "Warnlinie",
  "FinancialModel.avgMonthlyExpense": "Durchschnittliche monatliche Ausgaben",
  "FinancialModel.basedOnLast3Months":
    "Basierend auf dem Durchschnitt der letzten 3 Monate",
  "FinancialModel.remainingFunds": "Verbleibende Mittel",
  "FinancialModel.initialFunds": "Anfangskapital",
  "FinancialModel.currency.chf": "Schweizer Franken",
  "FinancialModel.fundSupportOver12Months":
    "Mittel reichen für mehr als 12 Monate",
  "FinancialModel.fundSupport6to12Months": "Mittel reichen für 6-12 Monate",
  "FinancialModel.fundSupportLess6Months":
    "Mittel reichen für weniger als 6 Monate",
  "FinancialModel.avgMonthlyExpenseCalc":
    "Berechnung der durchschnittlichen monatlichen Ausgaben",
  "FinancialModel.considerExpenseTrend":
    "Berücksichtigung des Ausgabentrends bei der Prognose",
  "FinancialModel.forecastLimit": "Prognosezeitraum",
  "FinancialModel.dataUpdateTime": "Datenaktualisierungszeit",
  // ===== 其它原有翻译 =====
  Product: "Produkt",
  "Header.productNav": "LUKKEY Produkt",
  Feature: "Merkmal",
  "About Us": "Über uns",
  FAQ: "Häufig gestellte Fragen",
  "Privacy Policy": "Datenschutzrichtlinie",
  "Help Center": "Hilfezentrum",
  "Header.infoMenu": "Mehr",
  "Header.appNow": "App laden",
  "Header.appModal.title": "LUKKEY App jetzt nutzen",
  "Header.appModal.subtitle": "Wählen Sie Ihre Plattform, um die offizielle mobile LUKKEY App zu erhalten.",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "Installieren Sie die offizielle App auf dem iPhone.",
  "Header.appModal.iosButton": "Öffnen",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Holen Sie sich die offizielle Android-App bei Google Play.",
  "Header.appModal.googlePlayButton": "Öffnen",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "Laden Sie die neueste offizielle APK direkt herunter.",
  "Header.appModal.androidButton": "Download",
  "Header.appModal.note": "Nur offizielle mobile Downloads. Verwenden Sie die obigen Links für die neueste Version.",
  "Academy": "Akademie",
  "Legal": "Rechtliches",
  "AboutUs.title": "Über LUKKEY",
  "AboutUs.lede": "LUKKEY ist eine Schweizer Hardware-Wallet-Marke, die sich dem höchsten Sicherheitsstandard für den Besitz digitaler Vermögenswerte verschrieben hat.",
  "AboutUs.vision.closing": "Deine Schlüssel. Deine Vermögenswerte. Deine Zukunft.",
  "AboutUs.quote": "LUKKEY bildet die Sicherheitsschicht zwischen Menschen und digitalen Vermögenswerten.",
  "AboutUs.block1": "LUKKEY hat seinen Sitz in der Schweiz. Das Unternehmen konzentriert sich auf Hardware-Wallets für sichere Selbstverwahrung.",
  "AboutUs.block2": "Die Produkte kombinieren Secure Elements, Manipulationsschutz und eine vollständig offline ausgelegte Architektur. Das Ziel ist, private Schlüssel in einer isolierten Umgebung zu halten.",
  "AboutUs.block3": "Das System ist ohne Wi‑Fi, USB oder direkte Netzwerkabhängigkeit konzipiert. Fingerabdruckzugang, NFC-Backup-Tools und die breite Asset-Unterstützung machen es im Alltag praktisch.",
  "AboutUs.block5": "LUKKEY verfolgt bei Kern-Firmware und -Software einen offenen und auditierbaren Ansatz. Sicherheitsaussagen sollten prüfbar und verifizierbar bleiben.",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "Supportanfrage",
  "WarrantySupport.intro": "Bitte füllen Sie die folgenden Informationen aus, um Ihre Supportanfrage zu senden.",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "Kurzbeschreibung",
  "WarrantySupport.form.issueTitle.placeholder": "Geben Sie eine kurze Zusammenfassung ein",
  "WarrantySupport.form.warrantyType.label": "Anfragetyp",
  "WarrantySupport.form.warrantyType.placeholder": "Anfragetyp auswählen",
  "WarrantySupport.form.warrantyType.product": "Geräteproblem",
  "WarrantySupport.form.warrantyType.service": "App-/Konto-Problem",
  "WarrantySupport.form.warrantyType.replacement": "Sonstiges",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "Beschreiben Sie das Problem oder Anliegen ausführlich",
  "WarrantySupport.form.submit": "Supportanfrage senden",
  "WarrantySupport.alert.success": "Ihre Supportanfrage wurde gesendet!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "Hilfezentrum",
  "HelpCenter.intro":
    "Willkommen im LUKKEY Help Center! Wenn du neu in der Kryptowelt bist oder Hilfe mit deiner Cold Wallet brauchst, bist du hier richtig. Unsere Cold-Wallet-Lösung bietet den sichersten Weg, digitale Assets zu speichern und zu verwalten. Unten findest du Antworten auf häufige Fragen und Tipps zur Fehlerbehebung.",
  "HelpCenter.section4.title": "Benötigen Sie weitere Unterstützung?",
  "HelpCenter.section4.intro":
    "Sparen Sie Zeit, indem Sie Ihre Supportanfrage online starten, und wir verbinden Sie mit einem Spezialisten. Aus Sicherheitsgründen wird der offizielle Support niemals nach Ihrer Recovery-Phrase oder Ihrem Private Key fragen:",
  "HelpCenter.contact.hint": "Nutzen Sie den Button, um eine Supportanfrage zu senden, wir melden uns per E-Mail.",
  "HelpCenter.cta.warranty": "Supportanfrage senden",
  brandName: "LUKKEY",
  tagline: "Verwalte deine Krypto-Währung wie nie zuvor",
  description:
    "Beginne deine Reise zur finanziellen Freiheit mit unserer App. Schütze deine Vermögenswerte mit unserer fortschrittlichen Cold-Wallet-Technologie und verwalte deine Finanzen intelligenter und effektiver. Dein finanzielles Wohlbefinden hat für uns oberste Priorität.",
  "home.seoTitle": "LUKKEY | Schweizer Hardware-Wallet für sichere Selbstverwahrung",
  "home.seoDescription": "LUKKEY ist eine Schweizer Hardware-Wallet-Marke mit Fokus auf Cold-Wallet-Sicherheit, Offline-Schutz privater Schlüssel, Fingerabdruckzugang und NFC-Backup für sichere Selbstverwahrung.",
  learnMore: "Mehr erfahren",
  "Lock Your Crypto, Securely": "Sperren Sie Ihre Krypto-Währung sicher",
  Testimonials: "Testimonials",
  Testimonial1:
    "Ich benutze diese Cold Wallet seit Monaten und bin von ihrer Zuverlässigkeit und den Sicherheitsfunktionen beeindruckt. Sehr zu empfehlen!",
  Testimonial2:
    "Dieses Cold Wallet hat meine Erwartungen übertroffen! Die benutzerfreundliche Oberfläche und die erstklassige Sicherheit machen es zu einem Muss für alle, die es mit Krypto ernst meinen.",
  Testimonial3:
    "Ich habe schon mehrere Cold Wallets ausprobiert, aber dieses sticht hervor. Das schlanke Design und die fortschrittlichen Funktionen machen die Verwaltung meiner Krypto-Vermögenswerte zu einem Kinderspiel.",
  "John Doe": "John Doe",
  "Cryptocurrency Enthusiast": "Kryptowährungs-Enthusiast",
  "Jane Smith": "Jane Smith",
  "Crypto Security Advocate": "Krypto-Sicherheitsbefürworter",
  "Alex Johnson": "Alex Johnson",
  "Investment Analyst": "Investment Analyst",
  "Touchscreen Interface": "Touchscreen-Oberfläche",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "Erleben Sie eine mühelose Verwaltung von Kryptowährungen mit unserer intuitiven Touchscreen-Oberfläche, die für eine schnelle und einfache Navigation durch Ihre digitalen Assets entwickelt wurde, was schnelle Transaktionen und sichere Verwaltung ermöglicht.",
  "Bluetooth Connectivity": "Bluetooth-Verbindung",
  "Wireless syncing with your devices for real-time updates.":
    "Drahtlose Synchronisierung mit Ihren Geräten für Echtzeit-Updates.",
  "Airtag Tracking": "Airtag-Tracking",
  "Track your wallet easily with built-in Airtag.":
    "Verfolgen Sie Ihre Brieftasche einfach mit dem eingebauten Airtag.",
  "Secure Chip Technology": "Sichere Chip-Technologie",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "Ausgestattet mit einem fortschrittlichen Sicherheitschip, der einen robusten Schutz für Ihre wertvollen digitalen Assets gegen unbefugten Zugriff und Cyber-Bedrohungen gewährleistet.",
  AboutUsDescription1:
    "Bei LUKKEY widmen wir uns der Bereitstellung von hochwertigen Lösungen für die sichere Verwaltung Ihrer Kryptowährungswerte.",
  AboutUsDescription2:
    "Unser Hauptsitz befindet sich in Zug, Schweiz. Mit einem Team von erfahrenen Fachleuten bemühen wir uns, zu innovieren und uns an die sich ständig verändernde Landschaft des Marktes für digitale Währungen anzupassen.",
  BlockchainNetworksSupported: "Unterstützte Blockchain-Netzwerke",
  CryptocurrenciesSupported: "Unterstützung von über 6.000 Kryptowährungen",
  Years: "Jahre",
  ExpertiseInSecurity: "Jahre an Sicherheitsexpertise",
  FrequentlyAskedQuestions: "Häufig gestellte Fragen",
  WhatIsColdWallet: "Was ist ein Cold Wallet?",
  ColdWalletDescription:
    "Ein Cold Wallet ist eine Art von Kryptowährungs-Wallet, das deine digitalen Assets offline speichert, was es weniger anfällig für Hacks und andere Online-Bedrohungen macht. Im Gegensatz zu Hot Wallets, die mit dem Internet verbunden sind und für häufige Transaktionen praktisch sind, sind Cold Wallets besser für die langfristige Aufbewahrung geeignet, da sie eine verbesserte Sicherheit bieten.",
  HowToSetUpColdWallet: "Wie richte ich mein Cold Wallet ein?",
  ColdWalletSetupDescription:
    "Die Einrichtung deines Cold Wallets beinhaltet normalerweise das Initialisieren des Geräts auf einer sicheren, offline Maschine. Du musst eine Wiederherstellungsphrase generieren und sicher aufbewahren, die erforderlich ist, um auf deine Assets zuzugreifen, falls das Gerät verloren geht oder fehlschlägt. Detaillierte Anweisungen werden mit deinem Kauf bereitgestellt, um einen reibungslosen Einrichtungsprozess zu gewährleisten.",
  CryptocurrenciesCompatibleWithColdWallet:
    "Welche Kryptowährungen sind mit deinen Cold Wallets kompatibel?",
  CryptocurrenciesCompatibilityDescription:
    "Unsere Cold Wallets unterstützen eine Vielzahl von Kryptowährungen, darunter die großen wie Bitcoin, Ethereum und Litecoin sowie verschiedene Altcoins. Für eine vollständige Liste der unterstützten Währungen besuche bitte unsere Website oder konsultiere die Produktdokumentation.",
  HowToSecureColdWallet: "Wie kann ich mein Cold Wallet sichern?",
  ColdWalletSecurityDescription:
    "Um dein Cold Wallet zu sichern, bewahre die Wiederherstellungsphrase immer an einem sicheren und privaten Ort auf, teile sie niemals mit jemandem und ziehe zusätzliche Sicherheitsmaßnahmen wie biometrische Sperren oder sichere Gehäuse in Betracht. Das regelmäßige Aktualisieren der Wallet-Firmware von der offiziellen Website hilft auch, Schwachstellen zu schützen.",
  ColdWalletNotWorking:
    "Was soll ich tun, wenn mein Cold Wallet nicht funktioniert oder wenn ich einen Fehler habe?",
  ColdWalletErrorDescription:
    "Wenn du Probleme mit deinem Cold Wallet hast, schaue im Abschnitt zur Fehlerbehebung in unserem Benutzerhandbuch nach. Bei spezifischeren Problemen kontaktiere unser Support-Team über unsere Website. Stelle sicher, dass du deine Gerätedaten griffbereit hast, um den Support-Prozess zu beschleunigen.",
  Community: "Gemeinschaft",
  "Join our community on your favorite platform to stay up-to-date, ask questions, and connect with other users.":
    "Treten Sie unserer Gemeinschaft auf Ihrer Lieblingsplattform bei, um auf dem Laufenden zu bleiben, Fragen zu stellen und sich mit anderen Benutzern zu verbinden.",
  "Subscribe.title": "Produkt-Updates erhalten",
  "Subscribe.subtitle":
    "Wir verfolgen Krypto-Trends für Sie. Erhalten Sie Produktupdates, Marktanalysen und exklusive Vorteile – direkt in Ihrem Posteingang.",
  "Subscribe.placeholder": "E-Mail-Adresse eingeben",
  "Subscribe.button": "Produkt-Updates abonnieren",
  "Subscribe.input.aria": "Eingabefeld für E-Mail-Adresse",
  "Subscribe.success":
    "Danke für Ihr Abonnement! Bitte prüfen Sie Ihr Postfach auf die Bestätigungs-E-Mail.",
  "Subscribe.error":
    "Abonnement fehlgeschlagen. Bitte versuchen Sie es später erneut.",
  "Subscribe.invalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  "Subscribe.privacy":
    "Ihre E-Mail-Adresse wird nur zum Versand unseres Newsletters und von Updates verwendet. Sie können das Abonnement jederzeit über den Link im Newsletter kündigen.",
  "Subscribe.learnMore":
    "Erfahren Sie mehr über den Umgang mit Ihren Daten und Ihre Rechte.",
  "Subscribe.popupCompact.title": "Auf dem Laufenden bleiben",
  "Subscribe.popupCompact.subtitle":
    "Produkt-Updates und Sicherheitsinfos. Kein Spam.",
  "Subscribe.popupCompact.button": "Abonnieren",
  "Subscribe.popupCompact.privacy":
    "Nur E-Mail. Jederzeit abbestellbar.",
  "SubscribeConfirmed.alt.success": "Abonnement bestätigt",
  "SubscribeConfirmed.alt.failed": "Abonnement fehlgeschlagen",
  "SubscribeConfirmed.title.success": "Abonnement bestätigt",
  "SubscribeConfirmed.title.failed": "Abonnement fehlgeschlagen",
  "SubscribeConfirmed.message.success":
    "Vielen Dank für die Bestätigung Ihrer E-Mail. Ihr Abonnement ist jetzt aktiv. Eine Willkommens-E-Mail wurde an Ihr Postfach gesendet.",
  "SubscribeConfirmed.message.failed":
    "Der Bestätigungslink ist ungültig oder abgelaufen. Bitte kehren Sie zur Startseite zurück und versuchen Sie, sich erneut zu abonnieren.",
  "SubscribeConfirmed.cta.backHome": "Zur Startseite",
  "SubscribeConfirmed.note.unsubscribe":
    "Sie können sich jederzeit über den Link in unseren E-Mails abmelden.",
  // ===== MarketView i18n =====
  "MarketView.title": "Markt-Dashboard",
  "MarketView.loading": "Lädt...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "Dieser Tab konnte nicht gerendert werden",
  "MarketView.unknownError": "Unbekannter Fehler",

  // ===== Common i18n =====
  "Common.refresh": "Aktualisieren",
  "Common.toggleSeriesVisibility": "Diese Reihe umschalten",
  "Common.error": "Fehler",
  "Common.dataUpdateTime": "Datenaktualisierungszeit",
  "Common.loading": "Lädt...",
  "Common.noDataSource": "Keine Daten (Datenquelle nicht bereitgestellt)",

  // ===== Common ranges =====
  "Common.to": "bis",
  "Common.clear": "Löschen",
  "Common.range.thisMonth": "Dieser Monat",
  "Common.range.lastMonth": "Letzter Monat",
  "Common.range.last2": "Letzte 2 Monate",
  "Common.range.last3": "Letzte 3 Monate",
  "Common.range.last6": "Letzte 6 Monate",
  "Common.range.thisYear": "Dieses Jahr",
  "Common.range.all": "Alle",
  "Common.range.custom": "Benutzerdefiniert",
  "Common.showFilters": "Filter anzeigen",
  "Common.hideFilters": "Filter ausblenden",
  "Common.search": "Suchen",
  "Common.priority": "Priorität",
  "Common.owner": "Verantwortlicher",
  "Common.collaborator": "Mitwirkende",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "Backend data/youtube_stats.json herunterladen",
  "YouTubeTab.downloadJson": "youtube_stats.json herunterladen",
  "YouTubeTab.loading": "YouTube-Kennzahlen werden geladen...",
  "YouTubeTab.errorHint":
    "Wenn kein API-Schlüssel konfiguriert ist, setzen Sie YOUTUBE_API_KEY oder GOOGLE_API_KEY in backend/.env und starten Sie das Backend neu.",
  "YouTubeTab.header.totalViews": "Gesamtaufrufe (Mehrkanal, Einheit: 10k)",
  "YouTubeTab.header.totalSubscribers":
    "Gesamtabonnenten (Mehrkanal, Einheit: 10k)",
  "YouTubeTab.dist.views": "Aufrufe-Verteilung (10k)",
  "YouTubeTab.dist.subscribers": "Abonnenten-Verteilung (10k)",
  "YouTubeTab.card.location": "Standort:",
  "YouTubeTab.card.registeredAt": "Registriert am:",
  "YouTubeTab.card.currentSubscribers": "Aktuelle Abonnenten",
  "YouTubeTab.card.currentVideos": "Aktuelle Videoanzahl",
  "YouTubeTab.card.currentTotalViews": "Aktuelle Gesamtaufrufe",
  "YouTubeTab.card.currentTotalComments": "Aktuelle Gesamtkommentare",
  "YouTubeTab.chart.totalSubscribers": "Gesamtabonnenten",
  "YouTubeTab.chart.totalViews": "Gesamtaufrufe",
  "YouTubeTab.chart.totalComments": "Gesamtkommentare",
  "YouTubeTab.chart.totalVideos": "Gesamtvideos",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "Backend data/x_stats.json herunterladen",
  "XTab.downloadJson": "x_stats.json herunterladen",
  "XTab.loading": "X-Kennzahlen werden geladen...",
  "XTab.errorHint":
    "Wenn kein Token konfiguriert ist, setzen Sie X_BEARER_TOKEN oder TWITTER_BEARER_TOKEN in backend/.env und starten Sie das Backend neu.",
  "XTab.header.totalFollowers":
    "Gesamtzahl der Follower (Mehrkanal, Einheit: 10k)",
  "XTab.header.totalEngagement":
    "Gesamt-Engagement (letzte 5 Beiträge: Likes + Retweets + Antworten + Zitate, Einheit: 10k)",
  "XTab.dist.followers": "Follower-Verteilung (10k)",
  "XTab.dist.engagement":
    "Engagement-Verteilung (letzte 5 Beiträge: Likes + Retweets + Antworten + Zitate, Einheit: 10k)",
  "XTab.card.currentFollowers": "Aktuelle Follower",
  "XTab.card.currentFollowing": "Aktuell folgt",
  "XTab.card.currentTweets": "Aktuelle Tweet-Anzahl",
  "XTab.card.recentLikes": "Neueste Likes (letzte 5 Beiträge)",
  "XTab.card.recentRetweets": "Neueste Retweets (letzte 5 Beiträge)",
  "XTab.card.recentReplies": "Neueste Antworten (letzte 5 Beiträge)",
  "XTab.card.recentQuotes": "Neueste Aufrufe (Inhaltsebene, letzte 5 Beiträge)",
  "XTab.card.listed": "Listenanzahl (Kanalebene)",
  "XTab.smallChart.followers": "Follower",
  "XTab.smallChart.tweets": "Tweets",
  "XTab.smallChart.likes": "Neueste Likes",
  "XTab.smallChart.retweets": "Neueste Retweets",
  "XTab.smallChart.replies": "Neueste Antworten",
  "XTab.smallChart.quotes": "Neueste Aufrufe (Inhaltsebene)",
  "XTab.smallChart.following": "Folgt",
  "XTab.smallChart.listed": "Gelistet",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "Nach Erstellungsmonat filtern:",
  "Analytics.dashboardTitle": "Dashboard zur Projektgesundheit",
  "Analytics.metric.completionRate": "Abschlussrate",
  "Analytics.metric.teamVelocity": "Teamgeschwindigkeit",
  "Analytics.metric.blockerRatio": "Blocker-Anteil",
  "Analytics.metric.workloadBalance": "Arbeitslast-Balance",
  "Analytics.charts.statusDistribution": "Statusverteilung",
  "Analytics.charts.statusByMonthPercent": "Status nach Monat (Prozentsatz)",
  "Analytics.charts.priorityDistribution": "Prioritätsverteilung",
  "Analytics.charts.priorityByMonthPercent":
    "Priorität nach Monat (Prozentsatz)",
  "Analytics.charts.functionTypeDistribution": "Funktions-Typ-Verteilung",
  "Analytics.charts.functionTypeByMonthPercent":
    "Funktions-Typ nach Monat (Prozentsatz)",
  "Analytics.blocker.ownerPie":
    "Blockierte Issues · Verantwortliche Verteilung (Donut)",
  "Analytics.blocker.ownerByMonth":
    "Blockierte Issues · Verantwortliche nach Monat (Prozentsatz)",
  "Analytics.bug.ownerPie": "Bug-Issues · Verantwortliche Verteilung (Donut)",
  "Analytics.bug.ownerByMonth":
    "Bug-Issues · Verantwortliche nach Monat (Prozentsatz)",
  "Analytics.ownerWorkloadDistribution": "Team-Arbeitslastverteilung",
  "Analytics.mode.priority": "Prioritätsverteilung",
  "Analytics.mode.status": "Statusverteilung",
  "Analytics.mode.type": "Typverteilung",
  "Analytics.blocker.attentionNeeded":
    "Issues, die sofortige Aufmerksamkeit erfordern",
  "Analytics.common.status": "Status",
  "Analytics.common.owner": "Verantwortlicher",
  "Analytics.insights.sectionTitle": "Projekteinblicke & Vorschläge",
  "Analytics.insights.efficiency.title": "Vorschläge zur Effizienzverbesserung",
  "Analytics.insights.efficiency.completionRate":
    "• Aktuelle Abschlussrate beträgt {{rate}}%, behalten Sie Blocker im Auge",
  "Analytics.insights.efficiency.avgVelocity":
    "• Durchschnittliche Teamgeschwindigkeit beträgt {{velocity}} Aufgaben/Person",
  "Analytics.insights.efficiency.workloadBalance":
    "• Arbeitslast-Balance beträgt {{balance}}%",
  "Analytics.insights.risk.title": "Risikowarnungen",
  "Analytics.insights.risk.blockerRatio": "• Blocker-Anteil {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• Anteil an P0-Issues {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• Zuerst Issues mit hoher Priorität lösen",

  // ===== Kanban i18n =====
  "Kanban.title": "Kanban-Ansicht",
  "Kanban.totalIssues": "Insgesamt {{count}} Issues",
  "Kanban.searchPlaceholder":
    "Suche nach Titel, Issue-Nummer, Verantwortlichen oder Mitwirkenden...",
  "Kanban.status.backlog": "Backlog",
  "Kanban.status.inProgress": "In Bearbeitung",
  "Kanban.status.blocked": "Blockiert / Bestätigung ausstehend",
  "Kanban.status.reviewTest": "Review / Test",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "Issue-Liste",
  "List.totalIssues": "Insgesamt {{count}} Issues",
  "List.viewDetails": "Details ansehen",
  "List.openInNewWindow": "In neuem Fenster öffnen",
  "List.empty.title": "Keine Issues",
  "List.empty.subtitle":
    "Erstellen Sie das erste Issue, um den Workflow zu starten",

  // ===== Assets Register i18n =====
  "Assets.title": "Asset-Register",
  "Assets.totalSets": "Gesamtanzahl",
  "Assets.table.employee": "Mitarbeiter",
  "Assets.table.setCount": "Sets",
  "Assets.table.model": "Modell",
  "Assets.total": "Gesamt",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "Projekt-Issue-Verfolgung",
  "LukkeyIssues.goToDemo": "Zur Demo-Seite",
  "LukkeyIssues.githubProject": "GitHub-Projekt ↗",
  "LukkeyIssues.githubManageIssues": "Issues direkt auf GitHub verwalten ↗",
  "LukkeyIssues.financeModel": "Finanzmodell",
  "LukkeyIssues.productCoreIssues": "Produkt-Kernprobleme",
  "LukkeyIssues.stats.totalIssues": "📊 Gesamtprobleme",
  "LukkeyIssues.stats.completed": "✅ Abgeschlossen",
  "LukkeyIssues.stats.inProgress": "🔄 In Bearbeitung",
  "LukkeyIssues.stats.pending": "⏳ Ausstehend",
  "LukkeyIssues.stats.blocked": "🚫 Blockiert",
  "LukkeyIssues.stats.docs": "📚 Dokumente",
  "LukkeyIssues.tabs.kanban": "Kanban-Ansicht",
  "LukkeyIssues.tabs.analytics": "Analytics",
  "LukkeyIssues.tabs.market": "Markt-Dashboard",
  "LukkeyIssues.tabs.assets": "Asset-Register",
  "LukkeyIssues.shareToChatGPT": "LUKKEY.json mit ChatGPT öffnen", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "LUKKEY Datenschutzrichtlinie",
  "PrivacyPolicy.intro.p1":
    "Bei LUKKEY sind wir der Ansicht, dass die sicherste Form von Privatsphäre die ist, die stets vollständig in den Händen der Nutzer bleibt.",
  "PrivacyPolicy.intro.p2":
    "Daher halten wir uns – unabhängig davon, ob Sie die LUKKEY Hardware-Cold-Wallet oder die begleitende LUKKEY Mobile-App (App) verwenden – strikt an ein unverrückbares Prinzip:",
  "PrivacyPolicy.intro.p3_strong":
    "Sofern der Nutzer nicht ausdrücklich autorisiert, erfassen, speichern oder laden wir keinerlei Nutzerinformationen hoch.",
  "PrivacyPolicy.intro.p3_tail":
    "Alle nutzungsbezogenen Daten werden ausschließlich lokal auf dem Gerät des Nutzers gespeichert und niemals an LUKKEY oder irgendeinen Server übertragen.",
  "PrivacyPolicy.intro.p4":
    "Diese Datenschutzrichtlinie erläutert, wie wir dieses Prinzip wahren.",

  "PrivacyPolicy.s1.title": "1. Geltungsbereich",
  "PrivacyPolicy.s1.appliesTo": "Diese Datenschutzrichtlinie gilt für:",
  "PrivacyPolicy.s1.item.hardware": "LUKKEY Hardware-Cold-Wallet",
  "PrivacyPolicy.s1.item.app": "LUKKEY Mobile-App (App)",
  "PrivacyPolicy.s1.principle":
    "Beide folgen dem einheitlichen Datenschutzprinzip „keine Erfassung, kein Upload, nur lokale Speicherung“.",

  "PrivacyPolicy.s2.title": "2. Informationen, die WIR NICHT erfassen",
  "PrivacyPolicy.s2.desc":
    "Zum Schutz Ihrer Privatsphäre verpflichten wir uns ausdrücklich, keinerlei Nutzerinformationen zu erfassen, hochzuladen oder zu speichern, einschließlich, aber nicht beschränkt auf:",
  "PrivacyPolicy.s2.li.identity":
    "Identitätsdaten: Name, Telefonnummer, E-Mail-Adresse, Postanschrift",
  "PrivacyPolicy.s2.li.walletSensitive":
    "Sensible Wallet-Daten: Private Keys, mnemonische Phrasen, Keystore-Dateien, Wallet-Passwörter",
  "PrivacyPolicy.s2.li.blockchain":
    "Blockchain-Daten: Wallet-Adressen, Transaktionshistorie, Asset-Informationen",
  "PrivacyPolicy.s2.li.behavior":
    "Nutzungsverhalten: App-Protokolle, Klickaufzeichnungen, Verhaltensanalysen",
  "PrivacyPolicy.s2.li.technical":
    "Technische Informationen: Gerätekennungen, Geolokation, IP-Adresse",
  "PrivacyPolicy.s2.inShort.title": "Kurz gesagt:",
  "PrivacyPolicy.s2.inShort.desc":
    "Alles, was Sie auf dem Hardwaregerät und in der App sehen, existiert nur auf Ihrem Gerät. LUKKEY hat keinen Zugriff darauf.",

  "PrivacyPolicy.s3.title":
    "3. Datenschutz- und Sicherheitsdesign des Hardware-Cold-Wallets",
  "PrivacyPolicy.s3.desc":
    "Die LUKKEY Cold Wallet bietet eine vollständig offline betriebene und sichere Umgebung. Zentrale Merkmale:",
  "PrivacyPolicy.s3.h1.title": "1. Sicherheits-Hardware auf Militärniveau",
  "PrivacyPolicy.s3.h1.l1": "EAL6+ zertifizierter Secure Element",
  "PrivacyPolicy.s3.h1.l2":
    "Vollständige, hardwareseitig verschlüsselte Kommunikation",
  "PrivacyPolicy.s3.h2.title": "2. Sicherheitsfunktionen",
  "PrivacyPolicy.s3.h2.l1": "Fingerabdruck-Authentifizierung",
  "PrivacyPolicy.s3.h2.l2": "Privatsphäremodus",
  "PrivacyPolicy.s3.h2.l3": "Isolierte Verwaltung mehrerer Wallets",
  "PrivacyPolicy.s3.h3.title": "3. Vollständige Isolation",
  "PrivacyPolicy.s3.h3.l1": "Keine Internetverbindung",
  "PrivacyPolicy.s3.h3.l2": "Keine Datenkabel-Verbindung",
  "PrivacyPolicy.s3.h4.title": "4. Manipulationssichere Selbstzerstörung",
  "PrivacyPolicy.s3.h4.desc":
    "Wird das Gerät zerlegt, beschädigt oder unbefugt angegriffen, zerstört der Secure Element automatisch sensible Daten, sodass private Schlüssel nicht extrahiert werden können.",
  "PrivacyPolicy.s3.h5.title":
    "5. Sensible Vorgänge ausschließlich im Secure Element",
  "PrivacyPolicy.s3.h5.l1": "Wallet-Erstellung",
  "PrivacyPolicy.s3.h5.l2": "Wallet-Import",
  "PrivacyPolicy.s3.h5.l3": "Transaktionssignatur",
  "PrivacyPolicy.s3.h5.note":
    "Alle sensiblen Prozesse finden zu 100 % im Secure Element statt und werden niemals einer unsicheren Chip- oder Speicherkomponente ausgesetzt.",
  "PrivacyPolicy.s3.h6.title":
    "6. Keine sensiblen Daten außerhalb des Secure Element",
  "PrivacyPolicy.s3.h6.desc":
    "In unsicheren Speicherbereichen des Geräts werden keine privaten Schlüssel, mnemonischen Phrasen oder sonstigen sensiblen Informationen abgelegt.",

  "PrivacyPolicy.s4.title":
    "4. Datenschutz- und Sicherheitsdesign der LUKKEY App",
  "PrivacyPolicy.s4.desc":
    "Die LUKKEY App dient ausschließlich der Anzeige von Informationen und der Bereitstellung von Benachrichtigungen. Sie verarbeitet keine sensiblen Wallet-Daten.",
  "PrivacyPolicy.s4.n1.title": "1. Was die App NICHT tut",
  "PrivacyPolicy.s4.n1.l1": "Erstellt keine Blockchain-Wallets",
  "PrivacyPolicy.s4.n1.l2": "Importiert keine Blockchain-Wallets",
  "PrivacyPolicy.s4.n1.l3":
    "Speichert keine privaten Schlüssel oder mnemonischen Phrasen",
  "PrivacyPolicy.s4.n1.l4": "Lädt keinerlei Nutzerdaten hoch",
  "PrivacyPolicy.s4.n1.l5":
    "Führt keine Verhaltensanalysen, Werbetrackings oder Datenerhebungen durch",
  "PrivacyPolicy.s4.n2.title": "2. Was die App TUT",
  "PrivacyPolicy.s4.n2.l1":
    "Zeigt durch die Hardware autorisierte, öffentlich zugängliche Informationen an",
  "PrivacyPolicy.s4.n2.l2":
    "Bietet ein Datenschutz-Einstellungsmenü mit Erläuterung zu jeder Berechtigung",
  "PrivacyPolicy.s4.n2.l3":
    "Gibt Nutzern volle Kontrolle zum jederzeitigen Aktivieren/Deaktivieren von Berechtigungen",
  "PrivacyPolicy.s4.n2.l4": "Bietet Maskierung sensibler Informationen",
  "PrivacyPolicy.s4.n2.l5":
    "Deaktiviert Bildschirmfoto/-aufnahme in bestimmten Ansichten",
  "PrivacyPolicy.s4.n2.l6":
    "Erkennt verdächtige Blockchain-Adressen über lokale Abgleiche",
  "PrivacyPolicy.s4.n2.l7":
    "Aktualisiert regelmäßig gefährliche URLs, Verträge und Adressen",
  "PrivacyPolicy.s4.n2.l8": "Einweg-Updatefluss nur vom Server → Gerät",
  "PrivacyPolicy.s4.n2.l9":
    "Während der Updates werden niemals Nutzerdaten zurückgesendet",
  "PrivacyPolicy.s4.n3.title": "3. Lokale Speicherung",
  "PrivacyPolicy.s4.n3.p1":
    "Die App speichert lokal ausschließlich nicht-private Daten wie UI-Präferenzen, Sprache und Theme. Diese Daten:",
  "PrivacyPolicy.s4.n3.l1": "werden nicht hochgeladen",
  "PrivacyPolicy.s4.n3.l2": "werden nicht synchronisiert",
  "PrivacyPolicy.s4.n3.l3": "sind für LUKKEY nicht zugänglich",

  "PrivacyPolicy.s5.title": "5. Datenübertragung & Serverrichtlinie",
  "PrivacyPolicy.s5.l1": "LUKKEY-Server speichern keine Nutzerinformationen",
  "PrivacyPolicy.s5.l2":
    "App–Server-Kommunikation ist auf Datenbank- und Versionsupdates beschränkt",
  "PrivacyPolicy.s5.l3":
    "Es werden keine Nutzerinformationen während der Kommunikation übertragen",
  "PrivacyPolicy.s5.l4":
    "Selbst bei einem Servereinbruch könnten keine Nutzerdaten offengelegt werden, da wir diese grundsätzlich nicht erheben",

  "PrivacyPolicy.s6.title": "6. Open-Source-Transparenz",
  "PrivacyPolicy.s6.l1": "Der Quellcode der LUKKEY App ist Open Source",
  "PrivacyPolicy.s6.l2":
    "Die eingebettete Firmware der LUKKEY-Hardware ist Open Source",
  "PrivacyPolicy.s6.l3": "Vollständig auf GitHub zur Prüfung verfügbar",
  "PrivacyPolicy.s6.p": "Transparenz ist Teil der Sicherheit.",

  "PrivacyPolicy.s7.title": "7. Vollständige Nutzerkontrolle",
  "PrivacyPolicy.s7.p":
    "Auch wenn wir keine Nutzerdaten erfassen, behalten Nutzer die vollständige Kontrolle über ihre Geräte:",
  "PrivacyPolicy.s7.l1": "Sie können App-Berechtigungen jederzeit deaktivieren",
  "PrivacyPolicy.s7.l2":
    "Sie können die App deinstallieren, um alle lokalen App-Daten zu entfernen",
  "PrivacyPolicy.s7.l3":
    "Sie können das Hardwaregerät zurücksetzen, um private Schlüssel und Wallet-Daten dauerhaft zu löschen",
  "PrivacyPolicy.s7.p2":
    "LUKKEY greift in diese Aktionen nicht ein und kann dies auch nicht.",

  "PrivacyPolicy.s8.title": "8. Kontakt",
  "PrivacyPolicy.s8.p":
    "Bei Fragen zu dieser Datenschutzrichtlinie kontaktieren Sie uns bitte:",
  "PrivacyPolicy.s8.email": "E-Mail: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "Adresse: LUKKEY Hauptsitz, Baarerstrasse 25, 6300 Zug, Schweiz",
  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "Wird überprüft...",
  "EmailOtp.title":
    "Eingeschränkter Zugriff: Name und E‑Mail eingeben, um einen Anmeldecode zu erhalten",
  "EmailOtp.nameLabel": "Name",
  "EmailOtp.namePlaceholder": "Geben Sie Ihren Namen ein",
  "EmailOtp.emailLabel": "E‑Mail",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "Code senden",
  "EmailOtp.resendCode": "Code erneut senden",
  "EmailOtp.resendWithCountdown": "Erneut senden ({{s}}s)",
  "EmailOtp.codeValidityHint":
    "Der Verifizierungscode ist etwa 10 Minuten gültig",
  "EmailOtp.codeLabel": "E‑Mail‑Verifizierungscode",
  "EmailOtp.codePlaceholder": "Den erhaltenen Code eingeben",
  "EmailOtp.signIn": "Anmelden",
  "EmailOtp.message.codeSent":
    "Verifizierungscode gesendet, bitte Posteingang prüfen",
  "EmailOtp.error.nameRequired": "Bitte geben Sie Ihren Namen ein",
  "EmailOtp.error.invalidEmail":
    "Bitte geben Sie eine gültige E‑Mail‑Adresse ein",
  "EmailOtp.error.sendFailed":
    "Senden des Verifizierungscodes fehlgeschlagen. Bitte versuchen Sie es später erneut.",
  "EmailOtp.error.codeRequired": "Bitte den Verifizierungscode eingeben",
  "EmailOtp.error.verificationFailed": "Verifizierung fehlgeschlagen",
  // ===== Academy i18n =====
  "Academy.hero.alert":
    "Sicherheitshinweis: Prüfen Sie Links stets und geben Sie Ihre Wiederherstellungsphrase niemals weiter.",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "Akademie",
  "Academy.hero.subtitle":
    "Praxisleitfäden zu Kryptosicherheit, Selbstverwahrung und der Nutzung der LUKKEY‑Cold‑Wallet.",
  "Academy.search.placeholder": "Tutorials, Best Practices und FAQs suchen…",
  "Academy.search.hint": "[ENTER]",
  "Academy.card.type.article": "ARTIKEL",
  "Academy.list.title": "Neueste Anleitungen",
  "Academy.list.viewAll": "ALLE ANZEIGEN",
  "Academy.list.empty":
    "Keine Ergebnisse. Versuchen Sie einen anderen Suchbegriff.",
  "Academy.image.placeholder": "BILD",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "Zurück zur Akademie",
  "AcademyArticle.notFound": "Artikel nicht gefunden",
  "AcademyArticle.author": "Autor",
  "AcademyArticle.unscheduled": "Kein geplanter Veröffentlichungszeitpunkt",
  "home.hero.reserveCtaLabel": "Frühzugang — 1 $",
  "home.hero.reserveCtaNote": "Voll erstattbar. Keine Kaufverpflichtung.",
};

export default translation;
